import { FASTElement as m, attr as u, observable as l } from "@microsoft/fast-element";
import { toasterStyles as p } from "./toaster.styles.js";
import { toasterTemplate as d } from "./toaster.template.js";
import { designTokens as f } from "../design-tokens.js";
var c = Object.defineProperty, h = (r, t, s, T) => {
  for (var i = void 0, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = a(t, s, i) || i);
  return i && c(t, s, i), i;
};
const o = class o extends m {
  constructor() {
    super(...arguments), this.position = "bottom-left", this.toasts = [];
  }
  toastsChanged() {
    const t = this.toasts.filter((s) => !s.show);
    for (const s of t)
      this.showToast(s);
  }
  showToast(t) {
    this._currentAnimation ? this._currentAnimation = this._currentAnimation.then(() => (this._currentAnimation = this.animateToast(t), this._currentAnimation)) : this._currentAnimation = this.animateToast(t);
  }
  animateToast(t) {
    return new Promise((s) => {
      t.show = !0, setTimeout(() => {
        s();
      }, this.getTransitionDuration());
    });
  }
  //TODO cache until theme changes
  getTransitionDuration() {
    var s;
    const t = (s = f.transition.fast.$value) == null ? void 0 : s.split(" ")[0];
    if (!t)
      return 0;
    if (t.endsWith("ms"))
      return parseInt(t.slice(0, -2));
    if (t.endsWith("s"))
      return parseInt(t.slice(0, -1)) * 1e3;
    throw new Error("Invalid duration. Must be in milliseconds or seconds.");
  }
  addToast(t) {
    this.appendChild(t);
  }
};
o.definition = {
  name: "toaster",
  template: () => d,
  styles: p
};
let e = o;
h([
  u
], e.prototype, "position");
h([
  l
], e.prototype, "toasts");
export {
  e as Toaster
};
